import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Grid,
  GridItem,
  Input,
  FormLabel,
  Select,
  Text,
  Button,
  IconButton,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { CloseIcon } from "@chakra-ui/icons";

const JobProfileAdvanceSearch = (props) => {
  const {
    state,
    allData,
    advanceSearch,
    setAdvanceSearch,
    isLoading,
    setGetTagValues,
    setSearchedData,
    setDisplaySearchData,
    setSearchClear,
    setSearchbox,
  } = props;

  const initialValues = {
    name: "",
  };
  const validationSchema = yup.object({
    name: yup.string(),
  });
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      const searchResult = allData?.filter((item) => {
        return (
          !values?.name ||
          (item?.name &&
            item?.name.toLowerCase().includes(values?.name?.toLowerCase()))
        );
      });
      let getValue = [values.name];
      setGetTagValues(getValue);
      setSearchedData(searchResult);
      setDisplaySearchData(true);
      setAdvanceSearch(false);
      resetForm();
      setSearchbox("");
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
    dirty,
  } = formik;

  return (
    <>
      <Modal
        onClose={() => {
          setAdvanceSearch(false);
          resetForm();
        }}
        isOpen={advanceSearch}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Advance Search</ModalHeader>
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={() => {
              setAdvanceSearch(false);
              resetForm();
            }}
            icon={<CloseIcon />}
          />

          <ModalBody>
            <Grid templateColumns="repeat(12, 1fr)" mb={3} gap={2}>
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="600"
                  color={"#000"}
                  mb="0"
                  mt={2}
                >
                  Name
                </FormLabel>
                <Input
                  fontSize="sm"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.name}
                  name="name"
                  placeholder="Enter Name"
                  fontWeight="500"
                />
                <Text mb="10px" color={"red"}>
                  {" "}
                  {errors.name && touched.name && errors.name}
                </Text>
              </GridItem>
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-btn3"
              size="sm"
              variant="brand"
              colorScheme="red"
              onClick={() => resetForm()}
            >
              Clear
            </Button>
            <Button
              className="theme-btn1"
              size="sm"
              variant="brand"
              ml={4}
              onClick={handleSubmit}
              disabled={isLoading || !dirty ? true : false}
            >
              {isLoading ? <Spinner /> : "Search"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default JobProfileAdvanceSearch;
